/**
 * @module lib/get-va-funding-fee
 */
import { VETERAN_TYPE_MILITARY } from '@nerdwallet/home-constants';
/**
 * Approximates the VA funding fee based on loan amount, down payment from last calculation cycle and type of veteran
 * @param {number} data.loanAmount  The loan amount
 * @param {number} data.outputDownPayment  The down payment from the last iteration of this calculation
 * @param {external:home-constants.VETERAN_TYPE} data.veteranType  The "type" of veteran
 * @param {boolean} data.firstVaLoan  Is this the user's first va loan?
 */

export default (function (_ref) {
  var loanAmount = _ref.loanAmount,
      outputDownPayment = _ref.outputDownPayment,
      veteranType = _ref.veteranType,
      firstVaLoan = _ref.firstVaLoan;
  var downPaymentPercent = outputDownPayment / (loanAmount + outputDownPayment);

  if (veteranType === VETERAN_TYPE_MILITARY) {
    if (downPaymentPercent >= 0.1) {
      return 0.0125;
    }

    if (downPaymentPercent >= 0.05) {
      return 0.015;
    }

    if (!firstVaLoan) {
      return 0.033;
    }

    return 0.0215;
  }

  if (downPaymentPercent >= 0.1) {
    return 0.015;
  }

  if (downPaymentPercent >= 0.05) {
    return 0.0175;
  }

  if (!firstVaLoan) {
    return 0.033;
  }

  return 0.024;
});